// DEPRECATED

const versionTag = "v2/chatter.js";
class CartAbandonment {
  enabled = false;
  detecting = false;

  intervals = [];
  timeouts = [];
  events = [];

  inactivityTimeout = false;
  navbarEnterDelay = false;
  windowExitDelay = false;
  activityTimeout = false;

  initiate = () => this.enabled = true;

  setConfig = ({
    inactivityTimeout,
    navbarEnterDelay,
    windowExitDelay,
    surveyId,
    activityTimeout
  }) => {
    this.inactivityTimeout = inactivityTimeout || this.inactivityTimeout;
    this.navbarEnterDelay = navbarEnterDelay || this.navbarEnterDelay;
    this.windowExitDelay = windowExitDelay || this.windowExitDelay;
    this.activityTimeout = activityTimeout || this.activityTimeout;
    if (!!surveyId) {
      const event = new Event("chatter-set-cart-abandonment-conversation");
      event.surveyId = parseInt(surveyId);
      document.dispatchEvent(event);
    }
  };

  detectInactivity = () => {
    if (this.inactivityTimeout) {
      let counter = 0;
      let interval = setInterval(() => {
        counter++;
        if (counter >= this.inactivityTimeout) {
          this.triggerCartAbandonment();
          console.debug(`${versionTag}: cart abandoned`);
        }
      }, 1000);
      this.intervals.push(interval);
      let refreshEvents = ["mousemove", "scroll", "keydown"];
      const resetInactivity = () => counter = 0;
      refreshEvents.forEach((e) => {
        document.addEventListener(e, resetInactivity);
      });
      refreshEvents.forEach(event => this.events.push({ event, listener: resetInactivity}));
    }
    
  };
  detectActivity = () => {
    if (this.activityTimeout) {
      let counter = 0;
      let interval = setInterval(() => {
        counter++;
        if (counter >= this.activityTimeout) {
          this.triggerCartAbandonment();
          console.debug(`${versionTag}: cart abandoned`);
        }
      }, 1000);
      this.intervals.push(interval);
    }
    
  };
  detectExitIntent = () => {
    let timeoutId = null;
    const exitListener = (e) => {
      if (e.clientY < 0 && this.navbarEnterDelay) {
        timeoutId = setTimeout(() => {
          this.triggerCartAbandonment();
          console.debug(`${versionTag}: cart abandoned`);
        }, this.navbarEnterDelay);
        this.timeouts.push(timeoutId);
      } else if ((e.clientX < 0 || e.clientX > window.innerWidth || e.clientY > window.innerHeight) && this.windowExitDelay) {
        timeoutId = setTimeout(() => {
          this.triggerCartAbandonment();
          console.debug(`${versionTag}: cart abandoned`);
        }, this.windowExitDelay);
        this.timeouts.push(timeoutId);
      }
    };
    document.addEventListener("mouseout", exitListener);
    this.events.push({ event: "mouseout", listener: exitListener });
    
    const enterListener = (e) => {
      clearTimeout(timeoutId);
    };
    document.addEventListener("mouseenter", enterListener);
    this.events.push({ event: "mouseenter", listener: enterListener });
  };
  enableCartAbandonmentDetection = () => {
    if (this.enabled) {
      this.detectInactivity();
      this.detectActivity();
      this.detectExitIntent();
      this.detecting = true;
    }
  };
  disableCartAbandonmentDetection = () => {
    this.intervals.forEach(interval => clearInterval(interval));
    this.timeouts.forEach(timeout => clearTimeout(timeout));
    this.events.forEach(({ event, listener }) => {
      document.removeEventListener(event, listener);
    });
    this.intervals = [];
    this.timeouts = [];
    this.events = [];
    this.detecting = false;
  };

  triggerCartAbandonment() {
    document.dispatchEvent(new Event("chatter-cart-abandoned"));
    this.disableCartAbandonmentDetection();
  }
  
}

const c = new CartAbandonment();
export default c;